<div class="bg-gray-50 min-h-screen">
  <div class="w-full px-4 py-8">
    @if(roleType === 'tenant' && HasRequiredPermissions) {
    <div>
      <label class="{{Skin.upperCaseSmallLabel}}">{{ 'entities.client.pluralName' | translate }}</label>

      <select (ngModelChange)="onClientSelected($event)" class="{{Skin.formInputSmallSize}} w-64"
        [(ngModel)]="currentClient">
        <option [value]="null" disabled>{{ 'Choose a client' | translate }}</option> <!-- Placeholder -->

        @for (client of clients; track client.id) {

        <option [ngValue]="client">{{ client.organizationName }}</option>
        }
      </select>
    </div>
    }
    @if ((roleType === 'tenant' && currentClient) || roleType === 'manager') {
    <app-role-list [isNested]="false" #roleList [roleType]="roleType">
    </app-role-list>
    }
  </div>
</div>